import script from "./TaskRow.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskRow.vue?vue&type=script&setup=true&lang=js"

import "./TaskRow.vue?vue&type=style&index=0&id=3b89d6aa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b89d6aa"]])

export default __exports__